import myMoment from 'moment-timezone'
export const getOnlyTimeZone = () => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return myMoment().tz(timeZone).format("z")
}